export const form1004 = [
	'overview',
	'subject',
	'neighborhood',
	'improvements',
	'comps',
	'salesapproach',
	'costapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview'
];

export const form107375 = [
	'overview',
	'subject',
	'neighborhood',
	'projectinformation',
	'projectanalysis',
	'unitdescription',
	'comps',
	'salesapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview'
];

export const form2055 = [
	'overview',
	'subject',
	'neighborhood',
	'improvements',
	'comps',
	'salesapproach',
	'costapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview'
];

export const formFNMA = [
	'overview',
	'arrival',
	'site',
	'structures',
	'pdfreview',
	'photoreview',
	'virtualtour'
];

export const inspection = ['overview', 'pdfreview', 'photoreview'];
